import * as coverNoteService from '../services/coverNoteRequests';
import { printPdfBlob } from './printPdfBlob';

/** Download common cover-note PDF and open the browser print dialog. */
export async function printCommonCoverNotePdf(
  caseRequestId: string,
  fileRef?: string,
): Promise<{ success: boolean; message?: string }> {
  const id = caseRequestId.trim();
  if (!id) return { success: false, message: 'Case request id is required.' };

  const r = await coverNoteService.downloadCommonCoverNotePdf(id);
  if (!r.success) return { success: false, message: r.message ?? 'Cover note PDF could not be loaded.' };

  const pdfBlob =
    r.data.type === 'application/pdf' ? r.data : new Blob([r.data], { type: 'application/pdf' });
  const safeRef = (fileRef?.trim() || 'document').replace(/[^\w.-]+/g, '_');
  printPdfBlob(pdfBlob, `Cover-Note-${safeRef}`);
  return { success: true };
}
